import * as dayjs from 'dayjs'

export class DateTimeFormatValueConverter {
  toView(value) {
      // mandag 8. mai kl 10:00
      return dayjs(value).format('dddd D[.] MMMM [kl] LT');
  }
}
